// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Place-bet success only — Lotus matched toast (#7B9B1E) */
.Toastify__toast.lotus-bet-matched-toast,
.Toastify__toast--success.lotus-bet-matched-toast {
  background: #7b9b1e !important;
  color: #fff !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.3) !important;
  padding: 12px 12px 12px 40px !important;
  min-height: 0 !important;
  max-width: 356px;
  margin: 12px auto;
  font-family: Lato, sans-serif;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-body,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-body {
  margin: 0;
  padding: 0;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  margin: 0;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon svg,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon svg {
  fill: #fff;
}

.lotus-bet-toast-title {
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #fff;
}

.lotus-bet-toast-msg {
  margin-top: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #fff;
}

.Toastify__toast.lotus-bet-matched-toast .Toastify__close-button,
.Toastify__toast--success.lotus-bet-matched-toast .Toastify__close-button {
  color: #fff;
  opacity: 0.85;
}

@media (max-width: 1119px) {
  .Toastify__toast.lotus-bet-matched-toast,
  .Toastify__toast--success.lotus-bet-matched-toast {
    width: calc(100% - 32px);
    max-width: none;
    margin: 12px auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/lotus-bet-matched-toast.css"],"names":[],"mappings":"AAAA,2DAA2D;AAC3D;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,sDAAsD;EACtD,uCAAuC;EACvC,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,aAAa;AACf;;AAEA;EACE;;IAEE,wBAAwB;IACxB,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Place-bet success only — Lotus matched toast (#7B9B1E) */\r\n.Toastify__toast.lotus-bet-matched-toast,\r\n.Toastify__toast--success.lotus-bet-matched-toast {\r\n  background: #7b9b1e !important;\r\n  color: #fff !important;\r\n  border-radius: 8px !important;\r\n  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.3) !important;\r\n  padding: 12px 12px 12px 40px !important;\r\n  min-height: 0 !important;\r\n  max-width: 356px;\r\n  margin: 12px auto;\r\n  font-family: Lato, sans-serif;\r\n}\r\n\r\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-body,\r\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-body {\r\n  margin: 0;\r\n  padding: 0;\r\n  color: #fff;\r\n}\r\n\r\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon,\r\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon {\r\n  position: absolute;\r\n  left: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 20px;\r\n  margin: 0;\r\n  color: #fff;\r\n}\r\n\r\n.Toastify__toast.lotus-bet-matched-toast .Toastify__toast-icon svg,\r\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__toast-icon svg {\r\n  fill: #fff;\r\n}\r\n\r\n.lotus-bet-toast-title {\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  line-height: 16px;\r\n  color: #fff;\r\n}\r\n\r\n.lotus-bet-toast-msg {\r\n  margin-top: 4px;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  line-height: 16px;\r\n  color: #fff;\r\n}\r\n\r\n.Toastify__toast.lotus-bet-matched-toast .Toastify__close-button,\r\n.Toastify__toast--success.lotus-bet-matched-toast .Toastify__close-button {\r\n  color: #fff;\r\n  opacity: 0.85;\r\n}\r\n\r\n@media (max-width: 1119px) {\r\n  .Toastify__toast.lotus-bet-matched-toast,\r\n  .Toastify__toast--success.lotus-bet-matched-toast {\r\n    width: calc(100% - 32px);\r\n    max-width: none;\r\n    margin: 12px auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
